import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ApiService} from '../../../@core/service/api.service';
import {
  BusinessModel,
  EActivityContentType,
  EBusinessType,
  EContactFieldType,
  EContactType, EProjectStatus,
  EProjectType,
} from '../../../@models';
import {IMultiSelectOption} from 'angular-2-dropdown-multiselect';
import * as saveAs from 'file-saver';
import {DatePipe} from '@angular/common';
import { AuthGuardService } from '../../../@core/service/auth-guard.service';

@Component({
  selector: 'ngx-sales-report',
  templateUrl: './project-report.component.html',
  styleUrls: ['./project-report.component.scss'],
})
export class ProjectReportComponent implements OnInit, OnDestroy {

  public reports: BusinessModel[] = null;
  public active: boolean[] = null;

  public activities: any[] = [];

  public projects: any[] = [];

  public filter: {
    regions: string[],
    rsms: string[],
    bus: string[],
    customers: string[],
    dateFrom: string,
    dateTo: string,
    activitytypes: [],
    hideTopics: boolean,

  } = {
    regions: [],
    rsms: [],
    bus: [],
    customers: [],
    dateFrom: null,
    dateTo: null,
    activitytypes: [],
    hideTopics: false,
  };


  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Page
  public p = 0;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  ActivityType = EActivityContentType;
  ProjectType = EProjectType;
  ProjectStatus = EProjectStatus;

  JSON = JSON;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public regions: IMultiSelectOption[];
  private regionSubscription: Subscription;

  public businessUnits: IMultiSelectOption[];
  private businessUnitSubscription: Subscription;

  public customers: IMultiSelectOption[];
  private customerSubscription: Subscription;


  public contacts: IMultiSelectOption[];
  private contactSubscription: Subscription;

  public activityTypes: IMultiSelectOption[] = [
    {id: EActivityContentType.QuickNote, name: EActivityContentType[EActivityContentType.QuickNote]},
    {id: EActivityContentType.Note, name: EActivityContentType[EActivityContentType.Note]},
    {id: EActivityContentType.VisitReport, name: EActivityContentType[EActivityContentType.VisitReport]},
    {id: EActivityContentType.OnlineMeeting, name: EActivityContentType[EActivityContentType.OnlineMeeting]},
    {id: EActivityContentType.TradeShowMeeting, name: EActivityContentType[EActivityContentType.TradeShowMeeting]},
    {id: EActivityContentType.OnSiteMeeting, name: EActivityContentType[EActivityContentType.OnSiteMeeting]},
    {id: EActivityContentType.Offer, name: EActivityContentType[EActivityContentType.Offer]},
    {id: EActivityContentType.Order, name: EActivityContentType[EActivityContentType.Order]},
    {id: EActivityContentType.OrderConfirmation, name: EActivityContentType[EActivityContentType.OrderConfirmation]},
    {id: EActivityContentType.Invoice, name: EActivityContentType[EActivityContentType.Invoice]},
    {id: EActivityContentType.ProjectSummary, name: EActivityContentType[EActivityContentType.ProjectSummary]},
  ];

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(private api: ApiService, private auth: AuthGuardService) { }

  private user;

  ngOnInit() {
    // this.api.loadMe().subscribe(user => {
    //   this.user = user;
    // });
    this.auth.loadMe().then(user => this.user = user);

    this.regionSubscription = this.api.reloadRegions().subscribe(regions => {
      this.regions = regions.map(x => {
        return {
          id: x._id,
          name: x.name,
        }
      });
    });
    this.businessUnitSubscription = this.api.reloadBusinessUnits().subscribe(bus => {
      this.businessUnits = bus.map(x => {
        return {
          id: x._id,
          name: x.name,
        }
      });
    });

    this.contactSubscription = this.api.reloadContacts({type: EBusinessType.NRK, contactType: EContactType.Employee})
      .subscribe(contacts => {
      this.contacts = contacts.map(x => {
        return {
          id: x._id,
          name: x.displayTitle,
        }
      })
    });

    this.customerSubscription = this.api.reloadBusiness()
      .subscribe(customers => {
        this.customers = customers/*.filter(x => x.type === EBusinessType.Customer)*/.map(x => {
          return {
            id: x._id,
            name: x.name,
          }
        })
      });
  }

  public loadReport() {
    this.api.salesReport(this.filter).subscribe(x => {
      this.reports = x;
      this.active = Array.apply(null, {length: this.reports.length}).map(() => false);
    });
  }

  public loadActivities(businessId: string) {
    this.activities = [];
    const ids = this.reports
      .find(x => x._id === businessId).projects
      .filter(x => this.filter.bus.length > 0 ? this.filter.bus.includes(x.businessUnit._id) : true)
      .map(x => x._id);
    this.filter.hideTopics = true;
    this.api.salesReportActivities(ids, this.filter).subscribe(x => this.activities = x);
    // this.api.)
  }

  public loadProjects(businessId) {
    const projects = this.reports
      .find(x => x._id === businessId).projects
      .filter(x => this.filter.bus.length > 0 ? this.filter.bus.includes(x.businessUnit._id) : true);

    this.projects = [];
    this.filter.hideTopics = false;
    projects.forEach(p => {
      this.api.salesReportActivities([p._id], this.filter).subscribe(x =>  this.projects[projects.indexOf(p)] = {
          name: p.name,
          value: x,
      });
    })
     // .map(x => x._id);
  }

  public getCountry(business: BusinessModel): string {

    const contact = business.contacts.find(x => Number(x.type) === Number(EContactType.General));
    if (contact == null) return 'Unknown';

    const country = contact.fields.find(x => Number(x.type) === Number(EContactFieldType.Country));
    return country != null ? country.value : 'Unknown';
  }

  public getCity(business: BusinessModel): string {
    const contact = business.contacts.find(x => Number(x.type) === Number(EContactType.General));
    if (contact == null) return 'Unknown';
    const city = contact.fields.find(x => Number(x.type) === Number(EContactFieldType.City));
    return city != null ? city.value : 'Unknown';
  }


  ngOnDestroy(): void {
    this.regionSubscription.unsubscribe();
    this.businessUnitSubscription.unsubscribe();
    this.contactSubscription.unsubscribe();
    this.customerSubscription.unsubscribe();
  }

  changePage(event: number) {
    this.p = event;
    const index = (this.p - 1) * 5;
    this.active = this.active.map((v, i) => i === index);
  }

  tabsChange($event: any) {
    const report = this.reports.find(x => x.name === $event.tabTitle);
    const index = this.reports.indexOf(report);
    this.active = this.active.map((v, i) => i === index);
  }


  downloadPdf() {
    this.api.downloadProjectReport(this.filter).subscribe(data => {
      /*const blob = new Blob([data], {
        type: 'application/vnd.ms-excel',
      });
      const url = window.URL.createObjectURL(blob);
      window.open(url);*/
      saveAs(data, `${ new DatePipe('en-US').transform(Date.now(), 'yyMMdd')}_Project Report_${this.user.short}.pdf`);
      // const user = {short: 'ps'};
      // console.log(user);

    });
  }
}
